


































import axios from 'axios';
import { Component, Vue } from 'vue-property-decorator';
import * as Sentry from '@sentry/browser';

import Alert from '@/components/Global/Alert.vue';
import Loading from '@/components/Global/Loading.vue';

@Component({
     components: {
          Alert,
          Loading,
     },
})
export default class Users extends Vue {
     private users: Array<{ sub: string; email: string }> = [];
     private loading: boolean = true;
     private error: boolean = false;

     private async created() {
          try {
               // $attrs.policyData
               const { data } = await axios.get(
                    process.env.VUE_APP_API_STAFF_URI +
                         // @ts-ignore
                         `/policy-users?policy=${this.$attrs.policyData.policy_number}&brand=${this.$attrs.policyData.brand}`,
               );

               this.users = data;
          } catch (e) {
               console.log(e);
               Sentry.captureException(e);
               this.error = false;
          } finally {
               this.loading = false;
          }
     }
}
//
